import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Item, PetCheckInsDetail, YearData, } from './../../interfaces/report';

import { DataMappingService } from 'src/app/services/data-mapping.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { PetService } from '../../services/pet.service'
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-monthly-revenues-per-item',
  templateUrl: './monthly-revenues-per-item.component.html',
  styleUrls: ['./monthly-revenues-per-item.component.scss']
})
export class MonthlyRevenuesPerItemComponent implements OnInit {
  petCheckInsDetail= {} as PetCheckInsDetail;
  selectedPetId = '';
  selectedPickUp: any;
  isLoading = false;
  pickUpUpdateData = new FormData();
  isSavingPickUp = false;
  public onClose= new Subject<boolean>();
  isPetCheckInsDetailLoaded = false;
  selectedYear = '';
  selectedMonth = '';
  isMonthlyRevenuesPerItemLoaded = false;
  monthlyRevenuesPerItem= [] as YearData[];
  filteredMonthlyRevenuesPerItem= [] as Item[];
  totalMonthlyRevenue = 0;

  constructor(private formBuilder: FormBuilder,
    private petService: PetService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private dataMappingService: DataMappingService,
    private jsonDataService: JsonDataService,
  ) {}

  ngOnInit(): void {
    console.log(`MonthlyRevenuePerItemComponent, ngOnInit, this is monthly revenue per item modal`);
    console.log(`MonthlyRevenuePerItemComponent, selectedYear: ${this.selectedYear}, selectedMonth: ${this.selectedMonth}`);

    if (this.selectedYear && this.selectedMonth) {
      console.log(`MonthlyRevenuePerItemComponent, selectedYear: ${this.selectedYear}, selectedMonth: ${this.selectedMonth}`);
      this.getMonthlyRevenuesPerItem();
    }
  }

  // Get monthly revenues per item
  getMonthlyRevenuesPerItem() {
    this.isMonthlyRevenuesPerItemLoaded = false;
    this.petService.getMonthlyRevenuePerItem().subscribe({
      next: (response) => {
        console.log(`getMonthlyRevenuesPerItem, response: ${JSON.stringify(response)}`);
        this.monthlyRevenuesPerItem = response;
        this.filteredMonthlyRevenuesPerItem = this.filterMonthlyRevenuesPerItemByYearAndMonth(this.selectedYear, this.selectedMonth);
        console.log(`getMonthlyRevenuesPerItem, filteredData: ${JSON.stringify(this.filteredMonthlyRevenuesPerItem)}`);
        this.totalMonthlyRevenue = this.calculateTotalMonthly();
        console.log(`getMonthlyExpensesPerItem, totalMonthlyRevenue: ${JSON.stringify(this.totalMonthlyRevenue)}`);
        this.isMonthlyRevenuesPerItemLoaded = true;
      },
      error: (error) => {
        this.isMonthlyRevenuesPerItemLoaded = true;
        console.error(`getMonthlyRevenuesPerItem, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of get monthly revenue per item

  // Filter monthly revenues per item by year and month
  filterMonthlyRevenuesPerItemByYearAndMonth(year: string, month: string): Item[] {
    let filteredData: Item[] = [];
    this.monthlyRevenuesPerItem.forEach(yearData => {
      console.log(`getMonthlyRevenuesPerItem, yearData: ${JSON.stringify(yearData)}`);
      if (year in yearData) {
        yearData[year].forEach(monthData => {
          console.log(`getMonthlyRevenuesPerItem, monthData: ${JSON.stringify(monthData)}`);
          if (month in monthData) {
            console.log(`getMonthlyRevenuesPerItem, month: ${JSON.stringify(month)}`);
            filteredData = monthData[month];
          }
        });
      }
    });
    return filteredData;
  } // End of filter monthly revenues per item by year and month

  calculateTotalMonthly() {
    // const filteredData = this.filterDataByYearAndMonth(year, month);
    let totalMonthly = 0;
    this.filteredMonthlyRevenuesPerItem.forEach(item => {
      totalMonthly += item.total;
    });
    return totalMonthly;
  }

  exportMonthlyRevenuesPerItemReport() {
    this.petService.exportMonthlyRevenuesPerItemToExcel().subscribe((data: any) => {
      this.saveFile(data, 'monthly_revenues_per_item_reports.xlsx');
    });
  } // End of exportMonthlyRevenuesPerItemReport

  private saveFile(data: any, filename: string) {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } // End of saveFile

  closeModal() {
    this.hideModal(false);
  } // end of closeModal

  hideModal(result: boolean) {
    this.onClose.next(result);
    this.bsModalRef.hide();
  } // end of hideModal
}
